<div class="ui-g-12">
  <div class="subtitle">
      <div class="campaign-coupon-sub">{{ 'campaign.threshold' | translate }}</div>
  </div>
  <div class="ui-g-8">
    <p-slider [style]="{'background-size':'100% 40px'}" [min]="category.soglia_min" [max]="category.soglia_max" [step]="coupon.passo_soglia" [range]="true" [(ngModel)]="category.soglia" (onChange)="changeCategorySettings()"></p-slider>
    <ol class="list-unstyled step-indicator step-indicator-horizontal step-indicator-xs">
      <li *ngFor="let value of category.soglia_slider; let i = index;">
        <ng-container [ngSwitch]="i">
          <div class="caption" *ngSwitchCase="0">{{ value | number:'.0-1' }}&euro;</div>
          <div class="caption" *ngSwitchCase="1" style="margin-left: 10px;">{{ value | number:'.0-1' }}&euro;</div>
          <div class="caption" *ngSwitchCase="2" style="text-align: center">{{ value | number:'.0-1' }}&euro;</div>
          <div class="caption" *ngSwitchCase="3" style="text-align: right; margin-right: 10px;">{{ value | number:'.0-1' }}&euro;</div>
          <div class="caption" *ngSwitchCase="4" style="text-align: right">{{ value | number:'.0-1' }}&euro;</div>
        </ng-container>
      </li>
    </ol>
  </div>
  <div class="ui-g-4" style="display: flex;">
    <div style="display: flex;">
        <p-spinner
        class="slider-field"
        size="5"
        [min]="category.soglia_min"
        [max]="category.soglia_max"
        [step]="coupon.passo_soglia"
        [(ngModel)]="category.soglia[0]"
        (onChange)="changeCategorySettings()"
        style="margin-right: 10px;"></p-spinner>
        <p-spinner
        size="5"
        [min]="category.soglia_min"
        [max]="category.soglia_max"
        [step]="coupon.passo_soglia"
        [(ngModel)]="category.soglia[1]"
        (onChange)="changeCategorySettings()"
        style="margin-right: 10px;"></p-spinner>
    </div>
    <div style="display: flex; flex-direction: column; margin-top: -16px;">
        <label style="max-width: 105px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">{{ 'campaign.thresholdDistance' |  translate}}</label>
        <p-spinner
        size="5"
        [min]="1"
        (onChange)="changeCategorySettings()"
        [(ngModel)]="category.step"></p-spinner>
    </div>

  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/views/campaign/new-campaign/step-4/coupons/category-coupons-slider/category-coupon-slider-3/category-coupon-slider-3.component.html